import { TASK_FROM_MESSAGE } from '@modules/atendimento/constants/Text'

// Rótulos de fallback por tipo de mídia quando a mensagem não tem texto.
const MEDIA_FALLBACK_LABEL = {
  imagem: 'imagem',
  audio: 'áudio',
  video: 'vídeo',
  documento: 'documento',
  sticker: 'figurinha',
}

// Descreve uma mensagem sem texto (mídia-only) para compor título/descrição.
// Inclui o nome do arquivo quando houver, garantindo contexto na tarefa.
const buildMediaLabel = (mensagem) => {
  const tipo = (mensagem && mensagem.tipo) || ''
  const base = MEDIA_FALLBACK_LABEL[tipo] || 'mensagem'
  const filename = mensagem && mensagem.media_filename
  if (filename) return base + ' (' + filename + ')'
  return base
}

/**
 * Deriva o título da tarefa a partir do conteúdo da mensagem.
 * Trunca em TITLE_MAX_LEN (com reticências) e NUNCA retorna string vazia —
 * mensagens mídia-only recebem fallback por tipo (EC-7).
 */
export const buildTaskTitleFromMessage = (mensagem) => {
  const conteudo = ((mensagem && mensagem.conteudo) || '').trim()
  if (!conteudo) {
    return 'Tarefa sobre ' + buildMediaLabel(mensagem)
  }
  const max = TASK_FROM_MESSAGE.TITLE_MAX_LEN
  if (conteudo.length <= max) return conteudo
  return conteudo.slice(0, max) + '...'
}

// Linha de atribuição: entrada usa o nome do remetente; saída é genérica.
const buildAttributionLine = (mensagem) => {
  const direcao = mensagem && mensagem.direcao
  if (direcao === 'entrada') {
    const nome =
      (mensagem && mensagem.remetente_nome) ||
      (mensagem && mensagem.nome_profissional_nota) ||
      'contato'
    return TASK_FROM_MESSAGE.DESCRIPTION_ATTRIBUTION_IN.replace('{nome}', nome)
  }
  return TASK_FROM_MESSAGE.DESCRIPTION_ATTRIBUTION_OUT
}

/**
 * Deriva a descrição da tarefa: linha de atribuição + conteúdo completo
 * (não truncado). Mensagens mídia-only carregam a indicação do tipo/arquivo.
 */
export const buildTaskDescriptionFromMessage = (mensagem) => {
  const attribution = buildAttributionLine(mensagem)
  const conteudo = ((mensagem && mensagem.conteudo) || '').trim()
  const body = conteudo || 'Mensagem com ' + buildMediaLabel(mensagem)
  return attribution + '\n' + body
}
